import React, { Fragment } from "react";
import { connect } from "react-redux";
import ErrorPage from "components/ErrorPage";
import Preloader from "components/Preloader";
import App from "../components/Stat";
import {
  toRenderbySiteStat,
  calculateSumByFields,
  chartData
} from "redux/selectors";
import FullLoader from '../../../components/FullLoader'

const Stat = ({ errors, isFetching, list, total, chartData }) => (
  <Fragment>
    {isFetching && <FullLoader />}
    {isFetching && <Preloader />}
    {!isFetching &&
      !errors && <App items={list} total={total} chartData={chartData} />}
    {errors && <ErrorPage errors={errors} />}
  </Fragment>
);

const mapStateToProps = state => {
  const {
    stat: { type: { bySite: { main: { errors, isFetching } } } }
  } = state;

  return {
    errors,
    isFetching,
    list: toRenderbySiteStat(state),
    total: calculateSumByFields(state),
    chartData: chartData(state)
  };
};

export default connect(mapStateToProps)(Stat);
